import isVolumeCompatible, {} from './supportsVolumeCompatibilityApi';
async function addVolumesToViewports(renderingEngine, volumeInputs, viewportIds, immediateRender = false, suppressEvents = false) {
    const compatibleViewports = [];
    for (const viewportId of viewportIds) {
        const viewport = renderingEngine.getViewport(viewportId);
        if (!viewport) {
            throw new Error(`Viewport with Id ${viewportId} does not exist`);
        }
        if (!isVolumeCompatible(viewport)) {
            console.warn(`Viewport with Id ${viewportId} does not implement addVolumes. Cannot add volume to this viewport.`);
            return;
        }
        compatibleViewports.push(viewport);
    }
    await Promise.all(compatibleViewports.map((viewport) => viewport.addVolumes(volumeInputs, immediateRender, suppressEvents)));
    return;
}
export default addVolumesToViewports;
